import * as baseState from 'store/initialState/baseState.js'
import * as columns from 'store/initialState/columns.js'
import * as screen from 'store/initialState/screenDimensions.js'
import * as langs  from 'store/initialState/langs/supported-langs.js'
import * as menus from 'store/initialState/menus.js'
import * as properties from 'store/initialState/state_properties.js'


export default {
    ...baseState.default,
    ...screen.default,
    ...langs.default,
    ...columns.default,
    ...menus.default,
    ...properties.default
  };

    
